module.exports = __webpack_public_path__ + "img/sbp-logo.5f993b8d.svg";